module.exports = __webpack_public_path__ + "img/header-weddingRingsSoleil.6144f11.webp";